













// vue
import {Vue, Component, Watch} from 'vue-property-decorator';

// 组件
import NewsArticleStyleOne from './NewsArticleStyleOne.vue';
import LayoutOne from '@/components/layouts/LayoutOne.vue';
import {Toast} from 'vant';

// http
import http from '@/utils/http';
import {newsDetailAPI} from '@/api/index';

@Component({
  components: {
    styleOne: NewsArticleStyleOne,
    layoutOne: LayoutOne,
  },
})
export default class App extends Vue {
  public layoutStyle: string = 'layoutOne';
  public mainStyle: string = 'styleOne';

  public data: any = {};

  public newsDetail = {};

  @Watch('$route')
  public watchData(value: any) {
    this.data = JSON.parse(value.query.data);
    this.getNewsDetail(this.data);
  }

  public mounted() {
    const data = this.$route.query.data;
    console.log(data);
    this.data = JSON.parse(data as string);
    this.getNewsDetail(this.data);
  }

  // 获取新闻详情
  public getNewsDetail(item: any) {
    return new Promise((resolve, reject) => {
      interface Body {
        type: string;
        id?: string;
        pid?: string;
      }

      const {id, type, catType} = item;
      const body: Body = {
        type: type ? type : catType,
      };

      if (type == '1' || catType == '1') {
        body.id = id;
      } else if (type == '2' || catType == '2') {
        body.pid = id;
      }

      const {requestInit} = newsDetailAPI;

      requestInit.body = JSON.stringify(body);

      http(newsDetailAPI).then((data: any) => {
        // 不显示底图
        if (body.type == '1') {
          data.imgUrl = '';
        }

        this.newsDetail = data;
      }).catch((reason) => {
        Toast('文章获取失败');
      });
    });
  }
}
